import React, { Component } from "react";
import { Typography, Grid } from "@material-ui/core";
import ImgButton from "../Helpers/ImgButton";
import TenantIcon from "../../images/icons/tenant_icon.png"
import LandlordIcon from "../../images/icons/landlord_icon.png"
import Link from "../Helpers/Link";
import LoginSuggestion from "../Helpers/LoginSuggestion";
import "./SignUp.css";

export default class SignUp extends Component {
    render() {
        return (
            <div className="Content-base">
                <div className="Content-title">
                    <Typography
                        variant="h5"
                        color="primary"
                    >
                        Welcome to Sopia! Please select your role
                    </Typography>
                </div>
                <div className="Content-form">
                    <Grid container direction="row"  justifyContent="center">
                        <Link to="/signup/tenant/0" styleName="SignUp-button">
                            <ImgButton 
                                src={TenantIcon}
                                alt="Tenant"
                                variant="contained"
                                color="primary"
                            >
                                Tenant
                            </ImgButton>
                        </Link>
                        <Link to="signup/landlord/" styleName="SignUp-button">
                            <ImgButton
                                src={LandlordIcon}
                                alt="Lessor"
                                variant="contained"
                                color="secondary"
                            >
                                Lessor
                            </ImgButton>
                        </Link>
                    </Grid>
                </div>
                <LoginSuggestion/>
            </div>
        );
    }
}